import React from 'react';

import AddressForm from '../../components/forms/AddressForm'
import {reduxForm} from 'redux-form'
import {connect} from 'react-redux'

import {validateTechnicalContact as validate} from '../../util/validate'
import {getInitialContactPerson} from "../../selectors/Forms";

function ContactPersonForm(props) {
    return <AddressForm id="contactPerson" {...props} />;
}

ContactPersonForm = reduxForm({form: 'contactPerson', destroyOnUnmount: false, validate})(ContactPersonForm) // eslint-disable-line
ContactPersonForm = connect(state => ({initialValues: getInitialContactPerson(state)}))(ContactPersonForm) // eslint-disable-line

export default ContactPersonForm



/** WEBPACK FOOTER **
 ** ./src/containers/clientdata/ContactPersonForm.js
 **/